// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".notifications-link[data-v-32858778]{\n  margin-bottom:var(--space-small)\n}", "",{"version":3,"sources":["/app/app/javascript/dashboard/components/layout/sidebarComponents/NotificationBell.vue"],"names":[],"mappings":"AAoCA;EACE;AAAA","file":"NotificationBell.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.notifications-link {\n  margin-bottom: var(--space-small);\n}\n"]}]);
// Exports
module.exports = exports;
